<script setup lang="ts">
  import { computed, watch } from 'vue'
  import { useProjectEstimator } from './composables/useProjectEstimator'

  const {
    form,
    sections,
    sectionFields,
    formContainer,
    activeSection,
    calculateWebsitePrice,
    calculateVideoPrice,
    calculateDesignPrice,
    websiteMaintenance,
    designSocialMediaService,
    videoServices,
    totalPrice,
    yearlyTotal,
    monthlyTotal,
    weeklyTotal,
    scrollToSection,
    setSectionRef,
  } = useProjectEstimator()

  const formJson = computed(() => {
    return JSON.stringify(form.value, null, 2)
  })

  watch(
    formJson,
    (newForm) => {
      console.log('formData:', newForm)
    },
    { deep: true, immediate: true },
  )
</script>

<template>
  <div class="font-display min-h-screen md:bg-[url('/assets/background.webp')] md:bg-cover md:bg-center bg-white">
    <header-banner />
    <div class="container mx-auto p-0 md:p-4 2xl:mt-10 mt-5 2xl:px-0">
      <!-- max-w-6xl -->
      <div class="bg-white shadow-lg overflow-hidden rounded-4xl md:rounded-4xl">
        <div class="flex flex-col md:flex-row h-full 2xl:max-h-[calc(100vh-12rem)] md:max-h-[calc(100vh-9rem)]">
          <sidebar-nav
            :sections="sections"
            :active-section="activeSection"
            :scroll-to-section="scrollToSection" />
          <div class="flex flex-col md:flex-row flex-1">
            <div
              ref="formContainer"
              class="flex-1 p-6 md:p-10 md:max-h-screen md:overflow-y-auto">
              <div class="mb-8">
                <h1 class="text-xl font-semibold text-secondary-3 xl:text-3xl">
                  Estimate Your Project Budget,
                  <span class="text-primary-700">Effortlessly!</span>
                </h1>
              </div>
              <section-form
                v-for="section in sections"
                :id="section.id"
                :key="section.id"
                :title="section.title"
                :fields="sectionFields[section.id]"
                :form-data="form"
                :set-section-ref="setSectionRef(section.id)" />
              <div class="text-sm text-gray-600 max-w-md pb-32 md:pb-0">
                <p>
                  No more confusion about your budget! Estimate your project
                  costs in minutes and focus on what truly matters:
                  <span class="font-bold text-primary-700 italic">bringing your ideas to life.</span>
                </p>
              </div>
              <div class="md:hidden fixed bottom-0 left-0 right-0 z-10">
                <summary-panel-mobile
                  :website-price="calculateWebsitePrice"
                  :design-price="calculateDesignPrice"
                  :video-price="calculateVideoPrice"
                  :website-maintenance="websiteMaintenance"
                  :design-social-media-service="designSocialMediaService"
                  :video-services="videoServices"
                  :total-price="totalPrice"
                  :yearly-total="yearlyTotal"
                  :monthly-total="monthlyTotal"
                  :weekly-total="weeklyTotal" />
              </div>
            </div>
            <div class="hidden md:w-80 border-t md:border-t-0 md:border-l border-gray-200 md:flex">
              <summary-panel
                :website-price="calculateWebsitePrice"
                :design-price="calculateDesignPrice"
                :video-price="calculateVideoPrice"
                :website-maintenance="websiteMaintenance"
                :design-social-media-service="designSocialMediaService"
                :video-services="videoServices"
                :total-price="totalPrice"
                :yearly-total="yearlyTotal"
                :monthly-total="monthlyTotal"
                :weekly-total="weeklyTotal" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
